module.exports = __webpack_public_path__ + "static/media/download-cloud-fill.0f3ba986.svg";